import { useState, useEffect } from 'react';

export const useTimeAgo = (timestamp) => {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    const updateTimeAgo = () => {
      if (!timestamp) {
        setTimeAgo('Unknown');
        return;
      }

      const now = Date.now();
      const diffMs = now - timestamp;
      
      // Convert to different units
      const diffSeconds = Math.floor(diffMs / 1000);
      const diffMinutes = Math.floor(diffSeconds / 60);
      const diffHours = Math.floor(diffMinutes / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffSeconds < 60) {
        setTimeAgo('Just now');
      } else if (diffMinutes < 60) {
        setTimeAgo(`${diffMinutes} min${diffMinutes !== 1 ? 's' : ''} ago`);
      } else if (diffHours < 24) {
        setTimeAgo(`${diffHours} hr${diffHours !== 1 ? 's' : ''} ago`);
      } else if (diffDays < 7) {
        setTimeAgo(`${diffDays} day${diffDays !== 1 ? 's' : ''} ago`);
      } else {
        // For older dates, show the actual date
        const date = new Date(timestamp);
        setTimeAgo(date.toLocaleDateString('en-US', { 
          month: 'short', 
          day: 'numeric',
          year: date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined
        }));
      }
    };

    // Update immediately
    updateTimeAgo();

    // Update every minute for recent timestamps
    const interval = setInterval(updateTimeAgo, 60000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return timeAgo;
};

export const formatTimeAgo = (timestamp) => {
  if (!timestamp) {
    return 'Unknown';
  }

  // Handle different timestamp formats
  let timestampMs = timestamp;
  
  // If timestamp is in seconds (less than year 2001 in milliseconds), convert to milliseconds
  if (timestamp < 1000000000000) {
    timestampMs = timestamp * 1000;
  }

  const now = Date.now();
  const diffMs = now - timestampMs;
  
  // Convert to different units
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  let result;
  if (diffSeconds < 0) {
    result = 'Future';
  } else if (diffSeconds < 60) {
    result = 'Just now';
  } else if (diffMinutes < 60) {
    result = `${diffMinutes} min${diffMinutes !== 1 ? 's' : ''} ago`;
  } else if (diffHours < 24) {
    result = `${diffHours} hr${diffHours !== 1 ? 's' : ''} ago`;
  } else if (diffDays < 7) {
    result = `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
  } else {
    // For older dates, show the actual date
    const date = new Date(timestampMs);
    result = date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined
    });
  }

  return result;
};